import React from 'react';
import { ModalContent } from '../../Modal';
import { ShowModalProps } from './type/props';

export const ShowModal = (props: ShowModalProps) => {  

  return (
    <ModalContent
      onBackdropClick={props.onClose}
      onCloseClick={props.onClose}
      mobile_menu 
      type={props.type}
      buttonClassName={props.buttonClassName}
      >
      {props.children}
    </ModalContent>
  );
};
